import dayjs from 'dayjs';
import React from 'react';
import { getBasicAuctions } from '~/helpers/orchestration/basicAuctions';
import provideDataHook from '~/helpers/provideDataHook';
import { useTranslation } from '~/Locale';
import { AuctionSitemap } from '../shared/interfaces/Auction';
import { RouteComponentProps } from '../shared/interfaces/routes';

interface LinkGraveyardProps extends RouteComponentProps {
  auctions: AuctionSitemap[];
}

export const LinkGraveyard = ({
  auctions: initialAuctions = []
}: LinkGraveyardProps) => {
  const { t } = useTranslation();
  const url = `/${t('ROUTES.AUCTIONS')}`;

  return (
    <ul style={{ padding: '1rem', margin: 0, listStyle: 'none' }}>
      <table>
        <thead>
          <tr>
            <th>{t('Auction id')}</th>
            <th>{t('Auction')}</th>
            <th>{t('Closed')}</th>
          </tr>
        </thead>

        <tbody>
          {initialAuctions.map(auction => (
            <tr key={auction.id}>
              <td>{auction.id}</td>
              <td>
                <a href={`${url}/${auction.slug}-${auction.id}`}>
                  {auction.slug}-{auction.id}
                </a>
              </td>
              <td>{dayjs(auction.closedAt).format('YYYY-MM-DD hh:mm')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </ul>
  );
};

const serverHook = async () => {
  const data = await getBasicAuctions('closed');
  const auctions = data.filter(auction => Boolean(auction.closedAt));
  return { auctions };
};

export default provideDataHook('link-graveyard', serverHook)(LinkGraveyard);
